import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { withStyles } from 'material-ui/styles';
import TextField from 'material-ui/TextField';
import debounce from 'lodash/debounce';

const styles = theme => ({
  root: {
    padding: theme.spacing.unit * 2,
    boxSizing: 'border-box',
  },
  multiline: {
    boxSizing: 'border-box',
    // marginTop: theme.spacing.unit,
    // paddingTop: theme.spacing.unit,
    // paddingBottom: theme.spacing.unit,
    lineHeight: 3 * theme.spacing.unit + 'px',
  },
  label: {
    position: 'relative',
  },
  helper: {
    textAlign: 'right',
  },
  helperError: {
    color: '#f00',
  },
});

class TextareaWidget extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      inputValue: props.value,
    };
  }

  throttledOnChange = debounce(value => {
    const { onChange } = this.props;
    onChange(value);
  }, 600);

  onChange = event => {
    this.setState({ inputValue: event.target.value });
    this.throttledOnChange(event.target.value);
  };

  //TODO: debug this along along with longe throttle time
  // onBlur = (id, event) => {
  //   const value = event.target.value;
  //   const { onBlur, onChange } = this.props;

  //   onBlur(id, value);

  //   this.setState({ inputValue: value });
  //   this.throttledOnChange.cancel();
  //   onChange(value);
  // };

  render = () => {
    const {
      classes,
      id,
      autofocus,
      options,
      disabled,
      readonly,
      formContext,
      label,
      onBlur,
      onFocus,
      schema,
    } = this.props;
    const { inputValue } = this.state;
    const { maxLength } = schema;
    const helperText = maxLength === undefined ? null : `${inputValue ? inputValue.length : 0} / ${maxLength}`;
    const helperClass = classnames(classes.helper, {
      [classes.helperError]: maxLength !== undefined && inputValue && inputValue.length > maxLength,
    });

    return (
      <TextField
        autoFocus={autofocus}
        className={classes.root}
        disabled={disabled || formContext.formStatus !== 'editable'}
        readOnly={readonly || formContext.formStatus !== 'editable'}
        fullWidth
        id={id}
        label={label}
        multiline
        {...maxLength !== undefined && { inputProps: { maxLength: maxLength } }}
        rows={options.rows}
        labelClassName={classes.label}
        InputLabelProps={{
          shrink: true,
        }}
        InputProps={{
          classes: { inputMultiline: classes.multiline },
        }}
        rowsMax={options.rows}
        value={inputValue === undefined ? '' : inputValue}
        onChange={this.onChange}
        // onBlur={event => this.onBlur(id, event)}
        onBlur={onBlur && (event => onBlur(id, event.target.value))}
        onFocus={onFocus && (event => onFocus(id, event.target.value))}
        helperText={helperText}
        helperTextClassName={helperClass}
      />
    );
  };
}
TextareaWidget.defaultProps = {
  autofocus: false,
  options: {
    rows: 4,
  },
};

TextareaWidget.propTypes = {
  classes: PropTypes.object.isRequired,
  schema: PropTypes.object.isRequired,
  formContext: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  options: PropTypes.shape({
    rows: PropTypes.number,
  }),
  value: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  readonly: PropTypes.bool,
  autofocus: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
};

export default withStyles(styles)(TextareaWidget);



// WEBPACK FOOTER //
// ./src/modules/common/components/form/widgets/TextareaWidget.js